export default __webpack_public_path__ + "static/media/RAPPORT GENERAL ANNUEL DES ACTIVITES 2022.b9c1cec5.pdf";